import React from 'react';
import PropTypes from 'prop-types';
import { ToastProvider, useToast } from 'react-native-toast-notifications';
import Snackbar from './snackbar';

function SnackbarProvider(_ref) {
  let {
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(ToastProvider, {
    renderToast: props => /*#__PURE__*/React.createElement(Snackbar, props)
  }, children);
}

SnackbarProvider.defaultProps = {
  children: ''
};
SnackbarProvider.propTypes = {
  children: PropTypes.node
};
const useSnackbar = useToast;
export { useSnackbar, SnackbarProvider };
//# sourceMappingURL=index.js.map